import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { companyAPI } from '../services/api';
import CompanyCard from '../components/CompanyCard';

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Redirect super admins to their dashboard
    if (user?.is_super_admin) {
      navigate('/admin/dashboard');
      return;
    }
    
    // Buyers can now see the home page and book meetings
    // No redirect for buyers anymore
    
    fetchCompanies();
  }, [user, navigate]);

  const fetchCompanies = async () => {
    try {
      const response = await companyAPI.getAll();
      setCompanies(response.data.companies);
    } catch (error) {
      setError('Error loading companies');
      console.error('Error fetching companies:', error);
    } finally {
      setLoading(false);
    }
  };

  // Don't render anything for super admins (they will be redirected)
  // Buyers can now see the home page
  if (user?.is_super_admin) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '50px',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: '3px solid #EDB404'
        }}>
          <h2 style={{ color: '#333', margin: '0' }}>Redirecting...</h2>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '50px',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: '3px solid #EDB404'
        }}>
          <h2 style={{ color: '#333', margin: '0' }}>Loading...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '50px', 
        color: 'white',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: '3px solid #e74c3c'
        }}>
          <h2 style={{ color: '#e74c3c', margin: '0' }}>⚠️ {error}</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      padding: 'clamp(20px, 5vw, 40px)'
    }}>
      <div style={{ 
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Header Section */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: 'clamp(30px, 6vw, 60px)',
          padding: 'clamp(20px, 4vw, 40px)'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: 'clamp(30px, 6vw, 50px)',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            border: '3px solid #EDB404'
          }}>
            <h1 style={{ 
              marginBottom: 'clamp(15px, 4vw, 25px)', 
              fontSize: 'clamp(2rem, 6vw, 3.5rem)', 
              fontWeight: '800',
              color: '#EDB404',
              lineHeight: '1.2'
            }}>
              Welcome to the Uzakrota Summit! 🚀
            </h1>
            <p style={{ 
              fontSize: 'clamp(1.1rem, 3.5vw, 1.4rem)', 
              color: '#555', 
              maxWidth: '900px', 
              margin: '0 auto', 
              lineHeight: '1.7',
              fontWeight: '500'
            }}>
              Connect with industry leaders and book your meetings with our amazing participants below.
            </p>
          </div>
        </div>
        
        {/* Companies Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(clamp(320px, 35vw, 380px), 1fr))',
          gap: 'clamp(20px, 4vw, 30px)',
          padding: '0 clamp(10px, 3vw, 20px)'
        }}>
          {companies.map((company) => (
            <div key={company.id} style={{
              transform: 'translateY(0)',
              transition: 'all 0.3s ease'
            }}>
              <CompanyCard company={company} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
